import { Injectable, inject } from '@angular/core';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root'
})
/** Service to maintain correlation ID across multiple API calls */
export class CorrelationIdService {
  private readonly utilityService = inject(UtilityService);

  private correlationId: string;

  constructor() {
    this.correlationId = this.utilityService.generateGuid();
  }

  public getCorrelationId(): string {
    return this.correlationId;
  }

  public resetCorrelationId(): void {
    this.correlationId = this.utilityService.generateGuid();
  }
} 